export * from './SharedModule';


// WEBPACK FOOTER //
// ./src/common/modules/shared/index.ts